import React from "react";

const ValidacoesCadastro = React.createContext();

export default ValidacoesCadastro;
